import React from 'react'

const FAQ = () => {
  return (
    <section id="faq" className="container relative mx-auto p-16">
  <h3 className="mb-14 text-center text-3xl font-semibold underline decoration-indigo-500/80 lg:text-left xl:text-4xl">
    Frequently Asked Questions
  </h3>
  <div className="my-6">
    <div className="rounded-t-2xl bg-teal-600/80 flex w-full cursor-pointer select-none items-center justify-between border-2 border-teal-600/30 px-4 py-4 text-gray-300 transition duration-300 hover:border-teal-600/80 hover:text-white">
      <h4 className="text-lg font-medium">What is SKULLA?</h4>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth={0}
        viewBox="0 0 448 512"
        height={22}
        width={22}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" />
      </svg>
    </div>
    <div className="inline-flex w-full rounded-b-2xl border-x-2 border-b-2 border-dashed border-teal-600/30 px-4 py-4 text-gray-300">
      <h5>
        SKULLA is a collection of 100 amazing figures with different
        attributes and styles hosted on Solana Blockchain. You can buy these
        figures on this site.
      </h5>
    </div>
  </div>
  <div className="my-6">
    <div className="rounded-t-2xl bg-teal-600/80 flex w-full cursor-pointer select-none items-center justify-between border-2 border-teal-600/30 px-4 py-4 text-gray-300 transition duration-300 hover:border-teal-600/80 hover:text-white">
      <h4 className="text-lg font-medium">How much do they Cost?</h4>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth={0}
        viewBox="0 0 448 512"
        height={22}
        width={22}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" />
      </svg>
    </div>
    <div className="inline-flex w-full rounded-b-2xl border-x-2 border-b-2 border-dashed border-teal-600/30 px-4 py-4 text-gray-300">
      <h5>
        SKULLA is a collection of 100 amazing figures with different
        attributes and styles hosted on Solana Blockchain. You can buy these
        figures on this site.
      </h5>
    </div>
  </div>
  <div className="my-6">
    <div className="rounded-t-2xl bg-teal-600/80 flex w-full cursor-pointer select-none items-center justify-between border-2 border-teal-600/30 px-4 py-4 text-gray-300 transition duration-300 hover:border-teal-600/80 hover:text-white">
      <h4 className="text-lg font-medium">Can I buy an NFT from this site?</h4>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth={0}
        viewBox="0 0 448 512"
        height={22}
        width={22}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" />
      </svg>
    </div>
    <div className="inline-flex w-full rounded-b-2xl border-x-2 border-b-2 border-dashed border-teal-600/30 px-4 py-4 text-gray-300">
      <h5>
        SKULLA is a collection of 100 amazing figures with different
        attributes and styles hosted on Solana Blockchain. You can buy these
        figures on this site.
      </h5>
    </div>
  </div>
</section>

  )
}

export default FAQ
